import { Box, Button, List, ListItem, Stack, Typography } from "@mui/material";
import { DefaultPopUp } from "components/DefaultPopUp/DefaultPopUp";
import { HittingAreaMarker } from "components/HittingAreaMarker/HittingAreaMarker";
import { LandingAreaMarker } from "components/LandingAreaMarker/LandingAreaMarker";
import { MarkerComponent } from "components/MarkerComponent/MarkerComponent";
import { StallsMarker } from "components/StallsMarker/StallsMarker";
import { TargetMarker } from "components/TargetMarker/TargetMarker";
import { TreeAreasMarker } from "components/TreeAreasMarker/TreeAreasMarker";
import { TreeMarker } from "components/TreeMarker/TreeMarker";
import { VegetationMarker } from "components/VegetationMarker/VegetationMarker";
import { WaterHazardMarker } from "components/WaterHazardMarker/WaterHazardMarker";
import { useEditableArea, useMapShapeData } from "hooks/MapDetails";
import asset from "json/assets";
import {
  MarkerColorType,
  MarkerType,
  TreeAreasMod2Type,
  TreeAreasType,
  TreeMod2Type,
  TreeType,
  VegtationAreasType,
  emptyPropElements,
  hittingAreasPrimay,
  hittingAreasType,
  landingAreasColor,
  landingAreasType,
  stallAreasType,
  targetColor,
  targetType,
  waterHazardType,
} from "json/constants";
import events from "json/events";
import React, { useCallback, useEffect, useState } from "react";
import Draggable from "react-draggable";
import { useDispatch } from "react-redux";
import {
  setShapePropertiesColor,
  setShapePropertiesType,
} from "redux/MapSlice";
import eventEmitter from "services/event.emitter";
import { getSelectedZoneFromEditableArea } from "services/utils";
import styles from "styles/component/CustomPopover.module.scss";

function CustomPopover(props) {
  const { title = "", zone = "" } = props;
  const dispatch = useDispatch();
  const [errorMsg, setErrorMsg] = useState("");
  const [markerType, setMarkerType] = useState();
  const [selectedMarkerMod2, setSelectedMarkerMod2] = useState();
  const [open, setOpen] = useState(false);
  const [defaultPos,setDefaultPos]=useState({x:0,y:0})
  eventEmitter.on(events.addMarkerToggle, (e) => {
    setOpen(e.visible);
  });
  const editableArea = useEditableArea();
  const shapeData = useMapShapeData();

  const handleSave = useCallback(() => {
    dispatch(setShapePropertiesType(markerType));
    dispatch(setShapePropertiesColor(selectedMarkerMod2));
    if (editableArea) {
      eventEmitter.emit(events.savePolygon);
    } else {
      eventEmitter.emit(events.addNewShape, { markerType, selectedMarkerMod2 });
    }

    setErrorMsg(""); //resetting error msg
    eventEmitter.emit(events.addMarkerToggle, { visible: false });
  }, [markerType, selectedMarkerMod2, editableArea]);

  const handleClose = () => {
    eventEmitter.emit(events.resetDrawingMode);
  };

  const handleChangeMarkerType = useCallback((event, value) => {
    setMarkerType(value);
  }, []);
  const handelChangeMarkerColor = useCallback((event, value) => {
    setSelectedMarkerMod2(value);
  }, []);

  useEffect(() => {
    if (open) {
      //checks only when modal is open

      const selectedZoneFromEditableArea =
        getSelectedZoneFromEditableArea(editableArea);
      const temp_selectedZoneDtls =
        selectedZoneFromEditableArea &&
        shapeData[`${selectedZoneFromEditableArea}`];
      if (editableArea && temp_selectedZoneDtls?.length > 0) {
        //if popup opened in edit mode, setting element color and type.
        let currentZoneDetails = temp_selectedZoneDtls.find((s) => {
          return s.label === editableArea;
        });
        setMarkerType(currentZoneDetails?.mod1);
        setSelectedMarkerMod2(currentZoneDetails?.mod2);
        dispatch(setShapePropertiesType(currentZoneDetails?.mod1));
        dispatch(setShapePropertiesColor(currentZoneDetails?.mod2));
        return;
      }

      if (title?.includes("Marker")) {
        setMarkerType(MarkerType[0]?.value);
        setSelectedMarkerMod2(MarkerColorType[0]?.value);
        dispatch(setShapePropertiesType(MarkerType[0]?.value));
        dispatch(setShapePropertiesColor(MarkerColorType[0]?.value));
      } else if (title?.includes("Landing")) {
        setMarkerType(landingAreasType[0]?.value);
        setSelectedMarkerMod2(landingAreasColor[0]?.value);
        dispatch(setShapePropertiesType(landingAreasType[0]?.value));
        dispatch(setShapePropertiesColor(landingAreasColor[0]?.value));
      } else if (title?.includes("Hitting")) {
        setMarkerType(hittingAreasType[0]?.value);
        setSelectedMarkerMod2(hittingAreasPrimay[0]?.value);
        dispatch(setShapePropertiesType(hittingAreasType[0]?.value));
        dispatch(setShapePropertiesColor(hittingAreasPrimay[0]?.value));
      } else if (title?.includes("Stall")) {
        setMarkerType(stallAreasType[0]?.value);
        dispatch(setShapePropertiesType(stallAreasType[0]?.value));
        // setSelectedMarkerMod2(hittingAreasPrimay[0]?.value)
      } else if (title?.includes("Target")) {
        setMarkerType(targetType[0]?.value);
        setSelectedMarkerMod2(targetColor[0]?.value);
        dispatch(setShapePropertiesType(targetType[0]?.value));
        dispatch(setShapePropertiesColor(targetColor[0]?.value));
      } else if (title?.includes("Vegetation")) {
        setMarkerType(VegtationAreasType[0]?.value);
        dispatch(setShapePropertiesType(VegtationAreasType[0]?.value));
      } else if (title === "Add Tree Areas" || title === "Edit Tree Areas") {
        setMarkerType(TreeAreasType[0]?.value);
        setSelectedMarkerMod2(TreeAreasMod2Type[0]?.value);
        dispatch(setShapePropertiesType(TreeAreasType[0]?.value));
        dispatch(setShapePropertiesColor(TreeAreasMod2Type[0]?.value));
      } else if (title === "Add Trees" || title === "Edit Trees") {
        setMarkerType(TreeType[0]?.value);
        setSelectedMarkerMod2(TreeMod2Type[0]?.value);
        dispatch(setShapePropertiesType(TreeType[0]?.value));
        dispatch(setShapePropertiesColor(TreeMod2Type[0]?.value));
      } else if (title?.includes("Water Hazards")) {
        setSelectedMarkerMod2(waterHazardType[0]?.value);
        dispatch(setShapePropertiesType(waterHazardType[0]?.value));
      }

      // else {
      setErrorMsg("");
      // }
    }
    return () => {
      setMarkerType();
      setSelectedMarkerMod2();
      
    };
  }, [title, open]);

  const getErrorMsgComponent = () => {
    return (
      <Box className={styles.errorBox}>
        <Stack direction={"row"} alignItems={"center"}>
          <Box className={styles.left_icon}>
            <img src={asset.update} alt="#Info" />
          </Box>
          <Box className={styles.info}>
            <Typography variant="body1">{errorMsg}</Typography>
          </Box>
        </Stack>
      </Box>
    );
  };
  return (
    <Box className={`${styles.sub_popover} ${styles.draggableDiv}`}>
      <Draggable bounds={"#DraggableContainer"}
      defaultPosition={{ x:0, y:0 }}
      key={Math.random()} //  resets the dragged modal to initial position on load ~ new key=> new DOM change
      >
        <Box
          className={`${styles.poover_content} ${styles.default_poover_content} custom_popover_content`}
          sx={{ opacity: open ? "1" : "0", display: open ? "block" : "none" }}
        >
          <Box className={styles.poover_head}>
            <Typography variant="h5">{title}</Typography>
            <List>
              <ListItem>
                <Button onClick={handleClose}>
                  <img src={asset.close} alt="" />
                </Button>
              </ListItem>
            </List>
          </Box>

          {title?.includes("Landing") && (
            <LandingAreaMarker
              markerType={markerType}
              handleChangeMarkerType={handleChangeMarkerType}
              selectedMarkerMod2={selectedMarkerMod2}
              handelChangeMarkerColor={handelChangeMarkerColor}
              errorMsg={errorMsg}
              handleSave={handleSave}
              errorComponent={getErrorMsgComponent}
            />
          )}

          {title?.includes("Hitting") && (
            <HittingAreaMarker
              markerType={markerType}
              handleChangeMarkerType={handleChangeMarkerType}
              selectedMarkerMod2={selectedMarkerMod2}
              handelChangeMarkerColor={handelChangeMarkerColor}
              errorMsg={errorMsg}
              handleSave={handleSave}
              errorComponent={getErrorMsgComponent}
            />
          )}
          {title?.includes("Markers") && (
            <MarkerComponent
              markerType={markerType}
              handleChangeMarkerType={handleChangeMarkerType}
              selectedMarkerMod2={selectedMarkerMod2}
              handelChangeMarkerColor={handelChangeMarkerColor}
              errorMsg={errorMsg}
              handleSave={handleSave}
              errorComponent={getErrorMsgComponent}
            />
          )}
          {title?.includes("Stall") && (
            <StallsMarker
              markerType={markerType}
              handleChangeMarkerType={handleChangeMarkerType}
              handelChangeMarkerColor={handelChangeMarkerColor}
              errorMsg={errorMsg}
              handleSave={handleSave}
              errorComponent={getErrorMsgComponent}
            />
          )}
          {title?.includes("Target") && (
            <TargetMarker
              markerType={markerType}
              handleChangeMarkerType={handleChangeMarkerType}
              selectedMarkerMod2={selectedMarkerMod2}
              handelChangeMarkerColor={handelChangeMarkerColor}
              errorMsg={errorMsg}
              handleSave={handleSave}
              errorComponent={getErrorMsgComponent}
            />
          )}

          {title?.includes("Vegetation") && (
            <VegetationMarker
              markerType={markerType}
              handleChangeMarkerType={handleChangeMarkerType}
              handelChangeMarkerColor={handelChangeMarkerColor}
              errorMsg={errorMsg}
              handleSave={handleSave}
              errorComponent={getErrorMsgComponent}
            />
          )}
          {(title === "Add Tree Areas" || title === "Edit Tree Areas") && (
            <TreeAreasMarker
              markerType={markerType}
              handleChangeMarkerType={handleChangeMarkerType}
              selectedMarkerMod2={selectedMarkerMod2}
              handelChangeMarkerColor={handelChangeMarkerColor}
              errorMsg={errorMsg}
              handleSave={handleSave}
              errorComponent={getErrorMsgComponent}
            />
          )}
          {(title === "Add Trees" || title === "Edit Trees") && (
            <TreeMarker
              markerType={markerType}
              handleChangeMarkerType={handleChangeMarkerType}
              selectedMarkerMod2={selectedMarkerMod2}
              handelChangeMarkerColor={handelChangeMarkerColor}
              errorMsg={errorMsg}
              handleSave={handleSave}
              errorComponent={getErrorMsgComponent}
            />
          )}
          {title?.includes("Water Hazards") && (
            <WaterHazardMarker
              markerType={markerType}
              handleChangeMarkerType={handleChangeMarkerType}
              selectedMarkerMod2={selectedMarkerMod2}
              handelChangeMarkerColor={handelChangeMarkerColor}
              errorMsg={errorMsg}
              handleSave={handleSave}
              errorComponent={getErrorMsgComponent}
            />
          )}
          {emptyPropElements.includes(zone) && (
            <DefaultPopUp
              errorMsg={errorMsg}
              handleSave={handleSave}
              handleClose={handleClose}
            />
          )}
        </Box>
      </Draggable>
    </Box>
  );
}
export default React.memo(CustomPopover);
